
export default store => {
  store.registerModule('timeouts', {
    state: {},
    mutations: {
      decrementTimeouts (state) {
        Object.keys(state).forEach((name) => {
          const { active, remaining } = state[name];
          const newValue = Math.max(remaining - 1000, 0);
          state[name] = {
            ...state[name],
            ...(active ? { remaining: newValue } : {}),
            ...(newValue === 0 ? { active: false } : {}),
          };
        }, {});
      },
      startTimeout (state, name) {
        state[name].active = true;
      },
    },
  });
  store.subscribe((mutation, state) => {
    if (mutation.type === 'addSecondsToCurrentTime') {
      store.commit('decrementTimeouts');
    }
  });
};
